module.exports = __webpack_public_path__ + "img/pencil.342bfe1f.svg";